module.exports = __webpack_public_path__ + "img/linkedin-logo-o.2a204d9b.svg";